import { decryptData, encryptData } from './encryption';

const LIVENESS_KEY = btoa('LIVENESS_DATA');

export const storeLiveness = (data) => {
  const encryptedData = encryptData(JSON.stringify(data));
  window.localStorage.setItem(LIVENESS_KEY, encryptedData);
};

export const getLiveness = () => {
  const jsonDataEncrypted = window.localStorage.getItem(LIVENESS_KEY);
  const jsonData = decryptData(jsonDataEncrypted);
  return JSON.parse(jsonData);
};

export const removeLiveness = () => {
  window.localStorage.removeItem(LIVENESS_KEY);
};

export const getItem = (key) => {
  try {
    const liveness = getLiveness();
    return liveness[key];
  }

  catch {
    return undefined;
  }
};

export const getParticipantEmail = () => {
  const participantEmail = getItem('participantEmail');
  return participantEmail;
};

export const getParticipantName = () => {
  const participantName = getItem('participantName');
  return participantName;
};

export const getParticipantPhone = () => {
  const participantPhone = getItem('participantPhone');
  return participantPhone;
};

export const getIsLivenessNode = () => {
  const participantPhone = getItem('isLivenessNode');
  return participantPhone;
};
